// extracted by mini-css-extract-plugin
export default {"ellipse":"Ellipse_ellipse__n09T9"};